@if (store.loadingFor('getFolderValidationErrors')()) {
    <app-loading></app-loading>
} @else if (store.validationErrors().length) {
    @for (error of store.validationErrors(); track error.id) {
        <app-person-error
            [message]="'errors.procedureValidation.' + error.error | translate:{ code: error.code }"
            [date]="error.date"
            severity="error"
            (closeEvent)="store.api.patchFolderValidationError({ id: error.id, silent: true })"
            (clickEvent)="goToVoucher(error)"
        ></app-person-error>
    }
} @else {
    <app-empty-state></app-empty-state>
}
